import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-modern-drawer/dist/index.css';
import HomePage from './pages/HomePage';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import BlankPage from "./pages/BlankPage";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<HomePage/>} />
        <Route path='/blank' element={<BlankPage/>} />
      </Routes>
    </BrowserRouter>
  )
}
